export default function CTASection() {
  return (
    <section id="download" className="relative w-full py-16 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20atmospheric%20background%20with%20warm%20orange%20and%20deep%20crimson%20gradient%2C%20abstract%20glowing%20particles%20floating%2C%20cinematic%20moody%20aesthetic%2C%20modern%20editorial%20style%2C%20clean%20composition%2C%20no%20text%2C%20subtle%20texture&width=1800&height=800&seq=cta-bg-download&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-950/95 via-background-950/80 to-background-950/95"></div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col lg:flex-row items-start gap-8 lg:gap-16">
            <div className="flex-1">
              <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-white leading-tight tracking-tight">
                随时随地<br />
                <span className="text-primary-400">最新吃瓜</span>
              </h2>
              <p className="text-sm md:text-base text-foreground-300 mt-3 md:mt-4 leading-relaxed max-w-md">
                下载51吃瓜APP，第一时间获取全网最新爆料视频。
              </p>
            </div>

            <div className="flex flex-col gap-3">
              <a
                href="#"
                className="inline-flex items-center justify-center gap-3 px-8 py-4 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap min-w-[200px]"
              >
                <i className="ri-android-line text-lg w-5 h-5 flex items-center justify-center"></i>
                Android 下载
              </a>
              <a
                href="#"
                className="inline-flex items-center justify-center gap-3 px-8 py-4 rounded-full bg-white text-foreground-900 font-semibold text-sm hover:bg-white/90 transition-all duration-200 whitespace-nowrap min-w-[200px]"
              >
                <i className="ri-apple-line text-lg w-5 h-5 flex items-center justify-center"></i>
                iOS 下载
              </a>
              <p className="text-[11px] text-foreground-500 mt-1">
                已通过安全检测，请放心下载安装
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mt-12 md:mt-16 pt-8 border-t border-white/10">
            <div className="text-center">
              <span className="text-2xl md:text-3xl font-heading font-bold text-white">580万+</span>
              <p className="text-xs text-foreground-400 mt-1">日活跃用户</p>
            </div>
            <div className="text-center">
              <span className="text-2xl md:text-3xl font-heading font-bold text-white">12万+</span>
              <p className="text-xs text-foreground-400 mt-1">累计爆料</p>
            </div>
            <div className="text-center">
              <span className="text-2xl md:text-3xl font-heading font-bold text-white">99.7%</span>
              <p className="text-xs text-foreground-400 mt-1">内容真实率</p>
            </div>
            <div className="text-center">
              <span className="text-2xl md:text-3xl font-heading font-bold text-white">890万+</span>
              <p className="text-xs text-foreground-400 mt-1">APP安装量</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}